"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOverflowDetector = void 0;
var react_1 = require("react");
var react_resize_detector_1 = require("react-resize-detector");
function useOverflowDetector(props) {
    var _a = (0, react_1.useState)(false), overflow = _a[0], setOverflow = _a[1];
    var ref = (0, react_1.useRef)();
    var updateState = (0, react_1.useCallback)(function () {
        if (ref.current == undefined) {
            return;
        }
        var newState = ref.current.offsetWidth < ref.current.scrollWidth || ref.current.offsetHeight < ref.current.scrollHeight;
        if (newState === overflow) {
            return;
        }
        setOverflow(newState);
        if (props.onChange) {
            props.onChange(newState);
        }
    }, [ref.current, props.onChange, setOverflow, overflow]);
    (0, react_resize_detector_1.useResizeDetector)({
        targetRef: ref,
        onResize: updateState,
    });
    (0, react_1.useEffect)(function () {
        updateState();
    });
    return {
        overflow: overflow,
        ref: ref,
    };
}
exports.useOverflowDetector = useOverflowDetector;
//# sourceMappingURL=useOverflowDetector.js.map